export const getIOSApi = () => {
    if (!('webkit' in window) || !isObject(window.webkit)) {
        return undefined;
    }
    if (!('messageHandlers' in window.webkit) || !isObject(window.webkit.messageHandlers)) {
        return undefined;
    }
    if (!('appTracking' in window.webkit.messageHandlers)) {
        return undefined;
    }
    return window.webkit.messageHandlers.appTracking;
};
export const getIOSEventLogger = () => {
    const iosApi = getIOSApi();
    if (!iosApi) {
        return undefined;
    }
    return (event) => {
        iosApi.postMessage({
            command: 'logGa4Event',
            name: event.name,
            parameters: event.params,
            options: {
                isPrivacyFriendly: event.isPrivacyFriendly,
            },
        });
    };
};
const isObject = (value) => {
    return typeof value === 'object' && value !== null;
};
//# sourceMappingURL=ios.js.map